import { Route } from "react-router-dom";
import { AdminAccess } from "../AdminAccess";
import { ShowProvider } from "../../../providers";

const adminAccessRoutes = [
  <Route
    key="admin-access"
    path="admin-access"
    element={
      <ShowProvider>
        <AdminAccess />
      </ShowProvider>
    }
  />,
];

export const ADMIN_ACCESS_ROUTES = adminAccessRoutes.map((route) => route);
